import * as actionTypes from '../actionTypes/fileFolderInfo';

export default {
  setCurrentFolder: (data) => ({
    type: actionTypes.SET_CURRENT_FOLDER,
    payload: {
      ...data,
    },
  }),
};
